import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Bannermain = () => {
  const bannerSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const researchSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const sponsorSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const bannerImages = [
    {
      src: require("../../assets/tools/blueproteinimage.jpg"),
      alt: "Image 1",
      caption: "Unveiling Molecular Mysteries"
    },
    {
      src: require("../../assets/tools/imageslider.jpg"),
      alt: "Image 2",
      caption: "Exploring Protein Structures"
    }
  ];

  const researchImages = [
    {
      src: require("../../assets/researchPapers/research0.png"),
      alt: "Research 0"
    },
    {
      src: require("../../assets/researchPapers/research0a.png"),
      alt: "Research 0a"
    },
    {
      src: require("../../assets/researchPapers/research0b.png"),
      alt: "Research 0b"
    },
    {
      src: require("../../assets/researchPapers/research0c.png"),
      alt: "Research 0c"
    },
    {
      src: require("../../assets/researchPapers/research0d.png"),
      alt: "Research 0d"
    },
    {
      src: require("../../assets/researchPapers/research3.png"),
      alt: "Research 3"
    },
    {
      src: require("../../assets/researchPapers/research4.png"),
      alt: "Research 4"
    },
    {
      src: require("../../assets/researchPapers/research1.png"),
      alt: "Research 1"
    },
    {
      src: require("../../assets/researchPapers/research2.png"),
      alt: "Research 2"
    },
    {
      src: require("../../assets/researchPapers/research5.png"),
      alt: "Research 5"
    },
    {
      src: require("../../assets/researchPapers/research6.png"),
      alt: "Research 6"
    },
    {
      src: require("../../assets/researchPapers/CICLOPinnercavity.png"),
      alt: "Ciclop inner cavity 2"
    },
    {
      src: require("../../assets/researchPapers/CICLOPwebdiagram.png"),
      alt: "Ciclop inner cavity 2"
    } 
  ];

  const sponsorImages = [
    {
      src: require("../../assets/sponsors/combined.png"),
      alt: "Sponsor 1"
    },
    {
      src: require("../../assets/sponsors/deptofbiotech.png"),
      alt: "Sponsor 2"
    },
    {
      src: require("../../assets/sponsors/nserbIndia.png"),
      alt: "Sponsor 3"
    },

  ];

  return (
    <div className="bg-white text-gray-800">
      {/* Banner Section */}
      <section className="w-full h-auto">
  <Slider {...bannerSettings}>
    {bannerImages.map((image, index) => (
      <div key={index} className="relative">
        <img src={image.src} alt={image.alt} className="w-full h-auto object-cover max-h-96" />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h2 className="text-white font-bold text-4xl md:text-5xl lg:text-6xl xl:text-6xl opacity-50">{image.caption}</h2>
        </div>
      </div>
    ))}
  </Slider>
</section>


      {/* About the Lab Section */}
      <section className="max-w-screen-xl mx-auto py-20 px-4 flex flex-col md:flex-row items-start">
        <div className="w-full md:w-1/2 mb-8 md:mb-0 order-2 md:order-1">
          <h2 className="text-3xl md:text-5xl font-bold text-designColor mb-4">About the Lab</h2>
          <p className="text-base text-gray-700 leading-relaxed">
            At Raylab, we merge molecular dynamics and machine learning to uncover the secrets of human biology. Our work on lipid metabolism, focusing on proteins like CETP and ABCA1, is geared toward developing cutting-edge treatments for cardiovascular conditions. We also drive forward CRISPR-Cas9 research, trying to reduce its off target effects. We are determined to study protein-ligand interactions, gene interactions and do comprehensive  network analysis to reveal the intricate connections between genes, proteins, and metabolic pathways, shedding light on the biology that underpins health and disease.
          </p>
        </div>
        <div className="w-full md:w-1/2 order-1 md:order-2 mt-8 md:mt-0">
          <Slider {...researchSettings}>
            {researchImages.map((image, index) => (
              <div key={index} className="relative">
                <img src={image.src} alt={image.alt} className="w-full h-auto object-contain max-h-128" />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Funded By Section */}
      <section className="max-w-screen-xl mx-auto py-20 px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-designColor text-center mb-8">Funded By</h2>
        <Slider {...sponsorSettings}>
          {sponsorImages.map((image, index) => (
            <div key={index} className="px-4">
              <img src={image.src} alt={image.alt} className="w-full h-32 object-contain" />
            </div>
          ))}
        </Slider>
      </section>
    </div>
  );
};

export default Bannermain;
